import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getSupabase } from '@/lib/db/client';
import { installVisibilityRefresh, logAuthBootstrap } from '@/lib/db/auth-session';
import { captureInviteTokenFromUrlEarly, normalizeMagicLinkHash } from '@/lib/invite-token';
import './index.css';

normalizeMagicLinkHash();
captureInviteTokenFromUrlEarly();
// Parse magic-link tokens from the URL before React mounts.
void getSupabase().auth.getSession().then(() => logAuthBootstrap());
installVisibilityRefresh();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
